// extracted by mini-css-extract-plugin
export default {"options-wrapper":"style_options-wrapper__wQ1tv"};